import Thor from '@qconcursos/thor';

const usejQ = (typeof fetch !== 'function');

window.Thor = Thor;
window.Thor.setup({ usejQ });

export default Thor;

